import PropTypes from "prop-types";
import React, { useReducer } from "react";

const ManagePaymentMethodsContext = React.createContext();

const defaultUserData = {
  paymentMethodsCanBeShared: false,
  otherHoHNames: [],
  hasMobilePhone: false,
  userID: null,
};

const initialState = {
  showQuickControls: false,
  onCardSelect: null,
  user: defaultUserData,
  paymentMethods: null,
  isCardAllowed: true,
  isACHAllowed: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "Set Payment Methods And User": {
      return {
        ...state,
        paymentMethods: action.payload.paymentMethods || [],
        user: action.payload.user || defaultUserData,
        isCardAllowed: action.payload.isCardAllowed,
        isACHAllowed: action.payload.isACHAllowed,
      };
    }

    case "Set Payment Methods": {
      const paymentMethods = action.payload.map((PM) => {
        PM.mounted = false;
        return PM;
      });
      return {
        ...state,
        paymentMethods,
      };
    }

    case "Set User": {
      return { ...state, user: action.payload };
    }

    case "Payment Method Mounted": {
      const paymentMethods = state.paymentMethods.map((PM) => {
        if (PM.ID === action.payload) PM.mounted = true;
        return PM;
      });
      return {
        ...state,
        paymentMethods,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

ManagePaymentMethodsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

function ManagePaymentMethodsProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ManagePaymentMethodsContext.Provider value={{ state, dispatch }}>
      {children}
    </ManagePaymentMethodsContext.Provider>
  );
}

function useManagePaymentMethods() {
  const context = React.useContext(ManagePaymentMethodsContext);
  if (context === undefined) {
    throw new Error(
      `useManagePaymentMethods must be used within a ManagePaymentMethodsProvider`
    );
  }
  return context;
}

export {
  ManagePaymentMethodsContext,
  ManagePaymentMethodsProvider,
  useManagePaymentMethods,
};
